module.exports = "#define GLSLIFY 1\nvec3 transformed = vec3( position );\n"